import React, { useEffect, useState } from "react";
import "./TimeInput.scss";
import { Input, InputGroup } from "rsuite";
import {TimeInputProps} from "./TimeInput.model";

const TimeInput = ({
  hours = 0,
  minutes = 0,
  onTimeChanged,
  maxHoursValue = 23,
  allowMinutes = true,
  label = null,
  width = "50px"
}: TimeInputProps) => {
  const [localHours, setLocalHours] = useState("");
  const [localMinutes, setLocalMinutes] = useState("");
  const regex = new RegExp(/^\d*$/, "m");

  useEffect(() => {
    setLocalHours(Number(hours) < 10 ? `0${Number(hours)}` : `${hours}`);
    setLocalMinutes(Number(minutes) < 10 ? `0${Number(minutes)}` : `${minutes}`);
  }, [hours, minutes]);

  const onChangeHours = (newValue: string) => {
    if (!regex.test(newValue)) return;

    const value = Number(newValue);

    if (value >= 0 && value <= maxHoursValue) {
      setLocalHours(newValue);
    }
  };

  const onChangeMinutes = (newValue: string) => {
    if (!regex.test(newValue)) return;

    const value = Number(newValue);

    if (value >= 0 && value <= 59) {
      setLocalMinutes(newValue);
    }
  };

  const onBlur = () => {
    if (Number(localHours) < 10) {
      setLocalHours(`0${Number(localHours)}`);
    }

    if (Number(localMinutes) < 10) {
      setLocalMinutes(`0${Number(localMinutes)}`);
    }

    if (typeof onTimeChanged === "function") {
      onTimeChanged({ hours: Number(localHours), minutes: Number(localMinutes) });
    }
  };

  return (
    <div className="time-input-container">
      <InputGroup style={{ height: 32 }}>
        {label && <InputGroup.Addon style={{ paddingLeft: 0 }}>{label}</InputGroup.Addon>}
        <Input
          value={localHours}
          onChange={onChangeHours}
          onBlur={onBlur}
          style={{ width: width, textAlign: "right", fontSize: 20, backgroundColor: "#d8e5fa", borderRadius: 0 }}
        />
        <InputGroup.Addon style={{ fontSize: 20, backgroundColor: "#d8e5fa" }}>:</InputGroup.Addon>
        {allowMinutes ? (
          <Input
            value={localMinutes}
            onChange={onChangeMinutes}
            onBlur={onBlur}
            style={{ width: width, fontSize: 20, backgroundColor: "#d8e5fa", borderRadius: 0 }}
          />
        ) : (
          <InputGroup.Addon color="#666666">00</InputGroup.Addon>
        )}
      </InputGroup>
    </div>
  );
};

export default TimeInput;
